<form
  class="behavior-code-reaction beahvior-code-reaction-default"
  [formGroup]="defaultBehaviorCodeReactionForm"
  novalidate>
  <mat-card
    appearance="outlined"
    class="behavior-code-reaction-form mat-elevation-z3">
    <mat-card-header class="behavior-code-reaction-form-header card-header">
      <mat-card-title>
        <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        {{title}}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="behavior-code-reaction-form-content">
      <div class="form-row">
      <app-autocomplete
        label="Reaction"
        placeholder="Reaction"
        (selectionChange)="setReaction($event)"
        [options]="reactionOptions"
        [(inputDisplay)]="noReactionOption"
      />
      </div>
      <div class="form-row">
        <mat-radio-group               
              matTooltip="First, save your behavior code with a default reaction. Then add a second Reaction to enable more options."
              matTooltipPosition="before"
              class="full-width-input-radio-buttons" 
              formControlName="reactionType">
          <mat-radio-button value="default" (change)="updateReactionType('default')"><b>Default:</b>&nbsp;Make this the default reaction</mat-radio-button>
          <mat-radio-button [disabled]="true" value="assignAt" (change)="updateReactionType('assignAt')"><b>Assign At:</b>&nbsp;This reaction will occur after a specific amount of tracks</mat-radio-button>
          <mat-radio-button [disabled]="true" value="selectMenu" (change)="updateReactionType('selectMenu')"><b>Select From Menu:</b>&nbsp;This reaction will be inside a menu and can be assign at any amount of tracks</mat-radio-button>
        </mat-radio-group>
        <div class="help-text"></div>
      </div>
      <div class="form-row" *ngIf="displayTriggerCount | async">
        <mat-form-field class="full-width-input">
          <mat-label>Assign At: Should happen after X entries</mat-label>
          <input matInput formControlName="triggerCount" type="number" />
          <app-error-display
            [form]="behaviorCodeReactionForm"
            controlName="triggerCount"></app-error-display>
        </mat-form-field>
        <small class="help-text">
          This action will occur after a student is tracked this amount of times.
        </small>
      </div>
      <div class="form-row">
        <mat-form-field class="full-width-input" subscriptSizing="dynamic">
          <mat-label>Remove or add points</mat-label>
          <input matInput formControlName="points" type="number" />
          <app-error-display
            [form]="defaultBehaviorCodeReactionForm"
            controlName="points"></app-error-display>
        </mat-form-field>
        <div class="help-text">
          <small>
            This action will add or remove the selected amount of points from a
            tracked student. Use negative numbers for removing points.
          </small>
        </div>
      </div>

      <div class="form-row">
        <mat-form-field class="full-width-input" subscriptSizing="dynamic">
          <mat-label>Repeat action X times when rule met</mat-label>
          <input matInput formControlName="reactionMultiplier" type="number" />
          <app-error-display
            [form]="defaultBehaviorCodeReactionForm"
            controlName="reactionMultiplier"></app-error-display>
        </mat-form-field>
        <div class="help-text">
          <small>
            This will multiply the action by the number selected. For example,
            if you select 2 for a detention, the student will be given 2
            detentions. This should not be changed in most cases.
          </small>
        </div>
      </div>

      <div class="form-row">
        <mat-form-field class="full-width-input" subscriptSizing="dynamic">
          <mat-label>Print X copies of each pass</mat-label>
          <input matInput formControlName="printCopies" type="number" />
          <app-error-display
            [form]="defaultBehaviorCodeReactionForm"
            controlName="printCopies"></app-error-display>
        </mat-form-field>
        <div class="help-text">
          <small>
            This will determine how many passes are printed by default when this
            action is used.
          </small>
        </div>
      </div>
      <div class="form-row" *ngIf="!(isDefault | async)">
        <mat-slide-toggle
          [color]="'primary'"
          class="filter-item"
          formControlName="active">
          Active
        </mat-slide-toggle>
      </div>
    </mat-card-content>
  </mat-card>
</form>
